import { render, staticRenderFns } from "./CalendarOverview.vue?vue&type=template&id=efd5aeaa&"
import script from "./CalendarOverview.vue?vue&type=script&lang=js&"
export * from "./CalendarOverview.vue?vue&type=script&lang=js&"
import style0 from "./CalendarOverview.vue?vue&type=style&index=0&id=efd5aeaa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports